import { HttpRequest } from "../../shared/ajax";
import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { UrlEnums } from "../../shared/utilities/enums/urlEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IProductReviewWidget, ProductReviewWidget } from "../reviewComponents/productReviewWidget";
import { IProductReviewsAggregate } from "../reviewComponents/reviewsAggregate";

const urlPaths = require('../../config/urlPaths.json');

export interface IProductReviewsParent extends IInstanceComponentBase {
    productReviewsAggregate: IProductReviewsAggregate
}

export class ProductReviewsParent extends InstanceComponentBase implements IProductReviewsParent {
    public lineId: number;
    public productReviewsAggregate: IProductReviewsAggregate = {} as IProductReviewsAggregate;
    public productReviewWidget: IProductReviewWidget;

    private readonly _handleRatingsOptionClick;
    private readonly _handleShowMoreClick;
    private readonly _handleScroll;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this._handleRatingsOptionClick = this.handleRatingsOptionClick.bind(this);
        this._handleShowMoreClick = this.handleShowMoreClick.bind(this);
        this._handleScroll = this.handleScroll.bind(this);

        this.productReviewWidget = new ProductReviewWidget(htmlElement);

        this.setLineId();

        this.attachRatingsOptionClickEventListener();
        this.attachShowMoreClickEventListener();
        this.attachScrollEventListener();
    }

    setLineId():void{
        this.lineId = +HelperUtils.getValueForElementAndAttributeOrThrows(this.htmlElement, AttributeEnums.Product.ProductLineId);
    }

    attachRatingsOptionClickEventListener(): void {
        console.log('ProductReviewsParent: attachRatingsOptionClickEventListener');
        this.htmlElement.addEventListener(CustomEventEnums.ReviewWidgetOptionSelected, this._handleRatingsOptionClick);
    }

    removeRatingsOptionClickEventListener(): void {
        console.log('ProductReviewsParent: removeRatingsOptionClickEventListener');
        this.htmlElement.removeEventListener(CustomEventEnums.ReviewWidgetOptionSelected, this._handleRatingsOptionClick);
    }

    attachShowMoreClickEventListener(): void {
        console.log('ProductReviewsParent: attachShowMoreClickEventListener');
        this.htmlElement.addEventListener(CustomEventEnums.ReviewWidgetPagerShowMore, this._handleShowMoreClick);
    }

    removeShowMoreClickEventListener(): void {
        console.log('ProductReviewsParent: removeShowMoreClickEventListener');
        this.htmlElement.removeEventListener(CustomEventEnums.ReviewWidgetPagerShowMore, this._handleShowMoreClick);
    }
    attachScrollEventListener(): void {
        console.log('ProductReviewsParent: attachScrollEventListener');
        document.addEventListener('scroll', this._handleScroll);
    }

    removeScrollEventListener(): void {
        console.log('ProductReviewsParent: removeScrollEventListener');
        document.removeEventListener('scroll', this._handleScroll);
    }

    async handleScroll() {
        let selectedRating: number = -1;
        let pageNumber: number = 1;
        let clearAllReviews: boolean = true;

        console.log(`ProductReviewsParent: handleScroll`);
        try {
            console.log(`ProductReviewsParent: handleScroll selectedRating: ${selectedRating} `);
            this.removeScrollEventListener();
                Promise.all([await this.getProductReviews(selectedRating, pageNumber), await this.getProductReviewsHtml(selectedRating, pageNumber)]).then((results) => {
                    this.updateWidget(results[1], clearAllReviews);
                  });
        } catch (error) {
            console.log(`ProductReviewsParent: handleScroll ERROR`, error);
        }
    }

    async handleRatingsOptionClick(e: CustomEvent) {
        let selectedRating: number = e.detail.rating;
        let isDisabled: boolean = e.detail.isDisabled;
        let pageNumber: number = 1;
        let clearAllReviews: boolean = true;

        console.log(`ProductReviewsParent: handleRatingsOptionClick`);
        try {
            console.log(`ProductReviewsParent: handleRatingsOptionClick selectedRating: ${selectedRating} `);
            if(!isDisabled){
                Promise.all([await this.getProductReviews(selectedRating, pageNumber), await this.getProductReviewsHtml(selectedRating, pageNumber)]).then((results) => {
                    this.updateWidget(results[1], clearAllReviews);
                  });
            }
        } catch (error) {
            console.log(`ProductReviewsParent: handleRatingsOptionClick ERROR`, error);
        }
    }

    async handleShowMoreClick(e: CustomEvent) {
        let isEof: boolean = e.detail.isEof;
        let pageNumber: number = e.detail.page;
        let selectedRating: number = e.detail.selectedRating;
        let clearAllReviews: boolean = false;

        console.log(`ProductReviewsParent: handleShowMoreClick`);
        try {
            console.log(`ProductReviewsParent: handleShowMoreClick`);
            if(!isEof){
                Promise.all([await this.getProductReviews(selectedRating, this.incrementPage(pageNumber)), await this.getProductReviewsHtml(selectedRating, this.incrementPage(pageNumber))]).then((results) => {
                    this.updateWidget(results[1], clearAllReviews);
                  });
            }
        } catch (error) {
            console.log(`ProductReviewsParent: handleShowMoreClick ERROR`, error);
        }
    }

    async getProductReviews(selectedRating:number, page: number): Promise<void> {
        try {
            console.log(`ProductReviewsParent: getProductReviews start lineId: ${this.lineId} selectedRating: ${selectedRating}, page: ${page}`);
            
            const uriSummary = `${urlPaths.websiteUrl}${UrlEnums.ApiUrls.ProductReviews}/${this.lineId}/${selectedRating}/${page}`;
            let response = await HttpRequest.get(uriSummary);
           
            this.productReviewsAggregate = JSON.parse(response);
            
            console.log("ProductReviewsParent: getProductReviews end");
        } catch (error) {
            console.log(`ProductReviewsParent: getProductReviews ERROR`, error);
        }
    }

    async getProductReviewsHtml(selectedRating:number, page: number): Promise<string>{
        try {
            console.log(`ProductReviewsParent: getProductReviewsHtml start lineId: ${this.lineId} selectedRating: ${selectedRating}, page: ${page}`);
            
            const uriSummary = `${urlPaths.websiteUrl}${UrlEnums.PartialUrls.Reviews}${this.lineId}/${selectedRating}/${page}`;
            let response: string = await HttpRequest.get(uriSummary);
        
            console.log("ProductReviewsParent: getProductReviewsHtml end");
            let reviewHtml: string = response;

            return reviewHtml;
        } catch (error) {
            console.log(`ProductReviewsParent: getProductReviewsHtml ERROR`, error);
            return null;
        }
    }

    incrementPage(page:number): number{
        return page + 1;
    }

    updateWidget(newReviews: string, clearReviews: boolean): void {
        console.log('ProductReviewsParent: updateWidget');  
        if(this.productReviewsAggregate === null || newReviews === null){
            console.log('ProductReviewsParent: updateWidget null values');  
        }else{
            this.productReviewWidget.update(this.productReviewsAggregate, newReviews, clearReviews);
        }
    }

    dispose() {
        try {
            console.log(`ProductReviewsParent: dispose`);
           
            this.removeRatingsOptionClickEventListener();
            this.removeShowMoreClickEventListener();
            this.removeScrollEventListener();

            if (this.productReviewWidget) {
                this.productReviewWidget.dispose();
            }
        } catch (error) {
            console.log('ProductReviewsParent: dispose ERROR', error);
        }
    }
}